import { Injectable } from '@angular/core';
import { Observable, catchError, map, retry } from 'rxjs';
import { getChatApiBaseUrl } from '../../utils/getChatApiBaseUrl';
import { HttpClient } from '@angular/common/http';
import { getDefaultRequestHeaderParams } from '../../utils/getRequestHeaderParams';
import { getWindowUrl } from '../../utils/getWindowUrl';
@Injectable({
  providedIn: 'root',
})
export class ProactiveChatService {
  constructor(private http: HttpClient) {}
  getProactiveChatConfig(language: string): Observable<ProactiveChatConfig> {
    const params = {
      proactiveChatUrl: getWindowUrl(),
      language,
    };
    return this.http
      .get(getChatApiBaseUrl() + '/chatadmin/proactivechat', {
        headers: {
          ...getDefaultRequestHeaderParams(),
        },
        params,
        withCredentials: true,
      })
      .pipe(
        retry(2),
        catchError((err) => {
          return err;
        }),
        map((res: any) => {
          if (res?.length) {
            return {
              engagements: this.convertProactiveChatData(res[0].engagement),
              currentIndex: -1,
            };
          } else {
            return {
              engagements: [],
              currentIndex: -1,
            };
          }
        })
      );
  }

  convertProactiveChatData(proactiveChatData): ProactiveEngagements[] {
    const newProactiveChatData: ProactiveEngagements[] = [];
    proactiveChatData?.forEach((element) => {
      const newElement = element;
      newElement.triggerAfter = parseInt(`${newElement.triggerAfter}000`);
      newElement.displayDuration = parseInt(`${newElement.displayDuration}000`);
      newProactiveChatData.push(newElement);
    });
    return newProactiveChatData;
  }
}
